import { markRaw } from 'vue';
import WidgetObjectUserAttributes from '@/views/contracts/object/object-card/Widgets/widget-object-user-attributes.vue';

const groups = [
    {
        id: 1,
        label: 'Основные реквизиты',
        collapsed: false,
    },
    {
        id: 2,
        label: 'Даты',
        collapsed: false,
    },
    {
        id: 3,
        label: 'Реквизиты',
        collapsed: false,
    },
];

const components = [
    //Основные реквизиты
    {
        fieldType: 'ai-form-text-box-readonly',
        title: 'Контрагент',
        groupId: 1,
        size: [1, 2],
        fieldNameText: 'contragent_name',
    },
    {
        fieldType: 'ai-form-text-box-readonly',
        title: '№ Договора',
        groupId: 1,
        size: [1, 1],
        fieldNameText: 'ndog',
    },
    {
        fieldType: 'ai-form-text-box-readonly',
        title: 'Филиал (отделение)',
        groupId: 1,
        size: [1, 2],
        fieldNameText: 'dep_name',
    },
    {
        fieldType: 'ai-form-text-box-readonly',
        title: 'Переоформлен с...',
        groupId: 1,
        size: [1, 1],
        fieldNameText: 'parent_obj',
    },
    {
        fieldType: 'ai-form-select-box',
        title: 'Статус',
        groupId: 1,
        size: [1, 1],
        fieldNameId: 'active_abbr',
        fieldNameText: 'pr_active',
        ds: [
            {
                pr_active: 0,
                active_abbr: 'А',
            },
            {
                pr_active: 2,
                active_abbr: 'Н',
            },
            {
                pr_active: 1,
                active_abbr: 'У',
            },
        ],
        extParams: {
            valueExpr: 'pr_active',
            displayExpr: 'active_abbr', // dictionaryRoutePath: '',
        },
    },
    {
        fieldType: 'ai-form-text-box',
        title: 'Номер',
        groupId: 1,
        size: [1, 1],
        fieldNameText: 'num_obj',
    },
    {
        fieldType: 'ai-form-text-box',
        title: 'Наименование',
        groupId: 1,
        size: [1, 2],
        fieldNameText: 'name',
    },
    {
        fieldType: 'ai-form-text-box',
        title: 'Назначение сооружения',
        groupId: 1,
        size: [1, 1],
        fieldNameText: 'naznhouse_name',
    },
    {
        fieldType: 'ai-form-text-box-grid-ro-dictionary',
        title: 'Субъект деятельности',
        groupId: 1,
        size: [1, 1],
        fieldNameId: 'kodagent',
        fieldNameText: 'ag_name',
        extParams: {
            displayExpr: 'name',
            valueExpr: 'kodagent',
            meta: {
                keyExpr: 'kodagent',
                columns: [
                    {
                        dataField: 'kodagent',
                        caption: 'kodagent',
                        visible: false,
                    },
                    {
                        dataField: 'name',
                        caption: 'Cубъект деятельности',
                    },
                    {
                        dataField: 'tmax1',
                        caption: 'Кол-во часов работы в месяц летом',
                    },
                    {
                        dataField: 'tmax',
                        caption: 'Кол-во часов работы в месяц зимой',
                    },
                    {
                        dataField: 'tgfe',
                        caption: 'Тангенс фи',
                    },
                    {
                        dataField: 'kzap',
                        caption: 'Коэфф-т заполнения графика',
                    },
                    {
                        dataField: 'prizn_kzap',
                        caption: 'Признак исп. знач. тангенса и коэф-та заполнения',
                        dataType: 'boolean',
                    },
                    {
                        dataField: 'koeff_ia',
                        caption: 'Коэфф-т пересчета из КВА в кВт',
                    },
                    {
                        dataField: 'tarifr',
                        caption: 'Надбавка к тарифу за реактив',
                    },
                    {
                        dataField: 'tarifg',
                        caption: 'Надбавка к тарифу за генерацию',
                    },
                    {
                        dataField: 'tarifr_minus',
                        caption: 'Скидка к тарифу за реактив',
                    },
                    {
                        dataField: 'tarifg_minus',
                        caption: 'Скидка к тарифу за генерацию',
                    },
                    {
                        dataField: 'koeffr',
                        caption: 'Коэфф-т прямого реактива от актива',
                    },
                    {
                        dataField: 'koeffg',
                        caption: 'Коэфф-т обратного реактива от актива',
                    },
                ],
                api: { select: 'object./agent/data/get' },
            },
        },
    },
    {
        fieldType: 'ai-form-text-box-grid-ro-dictionary',
        title: 'Классификатор потребителя',
        groupId: 1,
        size: [1, 1],
        fieldNameId: 'kod_f23',
        fieldNameText: 'name23',
        extParams: {
            displayExpr: 'name',
            valueExpr: 'kod_f23',
            meta: {
                keyExpr: 'kod_f23',
                columns: [
                    {
                        dataField: 'kod_f23',
                        caption: 'kod_f23',
                        visible: false,
                    },
                    {
                        dataField: 'npp',
                        caption: '№ п/п',
                    },
                    {
                        dataField: 'name',
                        caption: 'Наименование',
                    },
                    {
                        dataField: 'gr',
                        caption: 'Группа',
                    },
                    {
                        dataField: 'pr_byt',
                        caption: 'Бытовые',
                        dataType: 'boolean',
                    },
                ],
                api: { select: 'object./f23/data/get' },
            },
        },
    },
    {
        fieldType: 'ai-form-text-box',
        title: 'Тарифная группа',
        groupId: 1,
        size: [1, 2],
        fieldNameText: 'tarif_name',
    },
    {
        fieldType: 'ai-form-text-box-virtual-grid-dictionary',
        groupId: 1,
        title: 'Адрес',
        size: [1, 2],
        fieldNameId: 'kodd',
        fieldNameText: 'kf_adress_o',
        extParams: {
            displayExpr: 'kf_adress_o',
            valueExpr: 'kodd',
            loadUrl: 'object./address/data/get',
            keyExpr: 'kodd',
            autoLoadData: false,
            toRemoveToolbarItemsNames: ['copy', 'edit', 'add', 'delete', 'save'],
            columns: [
                {
                    field: 'kodd',
                    text: 'kodd',
                    visible: false,
                },
                {
                    field: 'postcode',
                    text: 'Почтовый индекс',
                    width: 100,
                },
                {
                    field: 'region',
                    text: 'Субъект федерации',
                    width: 100,
                },
                {
                    field: 'district',
                    text: 'Район (адм.)',
                    width: 100,
                },
                {
                    field: 'city',
                    text: 'Город (адм.)',
                    width: 100,
                },
                {
                    field: 'place',
                    text: 'Населенный пункт',
                    width: 100,
                },
                {
                    field: 'street',
                    text: 'Улица',
                    width: 200,
                },
                {
                    field: 'house',
                    text: 'Дом (здание, сооружен. и т.д.)',
                    width: 100,
                },
                {
                    field: 'flat',
                    text: 'Помещение в пределах дома',
                    width: 50,
                },
                {
                    field: 'room',
                    text: 'Комната',
                    width: 50,
                },
                {
                    field: 'guid',
                    text: 'GUID ГАР',
                    width: 200,
                },
                {
                    field: 'mark_addr',
                    text: 'Краткое написание адреса',
                },
                {
                    field: 'district_m',
                    text: 'Муниципальный р-н (округ) \\ Городской округ \\ Внутригородская терр. ГФЗ',
                    visible: false,
                },
                {
                    field: 'poselen_m',
                    text: 'Городское(сельское) поселение \\ Межселенная территория \\ Внутригородской р-н Г.О.',
                    visible: false,
                },
                {
                    field: 'plan',
                    text: 'Планировочная структура',
                    visible: false,
                },
                {
                    field: 'kf_adress_o',
                    text: 'kf_adress_o',
                    visible: false,
                },
            ],
        },
    },
    {
        fieldType: 'ai-form-radio-box',
        title: 'Тепловой \\ Электрический',
        groupId: 1,
        size: [1, 1],
        fieldNameText: 'tep_el',
        extParams: {
            displayExpr: 'tep_el_name',
            valueExpr: 'tep_el',
            layout: 'horizontal',
            items: [
                {
                    tep_el: 1,
                    tep_el_name: 'Эл-во',
                },
                {
                    tep_el: 2,
                    tep_el_name: 'Тепло',
                },
            ],
        },
    },
    {
        fieldType: 'ai-form-text-box',
        title: 'Площадь общего имущества, кв.м.',
        groupId: 1,
        size: [1, 1],
        fieldNameText: 'square_oi',
    },
    {
        fieldType: 'ai-form-text-box',
        title: 'Площадь объекта, кв.м.',
        groupId: 1,
        size: [1, 1],
        fieldNameText: 'square',
    },
    {
        fieldType: 'ai-form-text-box',
        title: 'Кол-во комнат (помещ.)',
        groupId: 1,
        size: [1, 1],
        fieldNameText: 'kol_kom',
    },
    {
        fieldType: 'ai-form-text-box',
        title: 'Кол-во квартир',
        groupId: 1,
        size: [1, 1],
        fieldNameText: 'apartment',
    },
    {
        fieldType: 'ai-form-text-box',
        title: 'Площадь аренды, кв.м',
        groupId: 1,
        size: [1, 1],
        fieldNameText: 'square_rent',
    },
    {
        fieldType: 'ai-form-text-box',
        title: 'Норматив СОИ, кВт*ч/кв.м',
        groupId: 1,
        size: [1, 1],
        fieldNameText: 'nrm_soi',
    },
    {
        fieldType: 'ai-form-date-box',
        title: 'Создан',
        groupId: 2,
        size: [1, 1],
        fieldNameText: 'dat_create',
    }, //Даты
    {
        fieldType: 'ai-form-date-box',
        title: 'Начало действия в тек. дог.',
        groupId: 2,
        size: [1, 1],
        fieldNameText: 'dat_parent_create',
    },
    {
        fieldType: 'ai-form-date-box',
        title: 'Прекращен',
        groupId: 2,
        size: [1, 1],
        fieldNameText: 'dat_fin',
    },
    {
        fieldType: 'ai-form-date-box',
        title: 'Планируемое окончание',
        groupId: 2,
        size: [1, 1],
        fieldNameText: 'dat_plan_fin',
    },
    {
        fieldType: 'ai-form-date-box',
        title: 'Дата техн. присоед.',
        groupId: 2,
        size: [1, 1],
        fieldNameText: 'dat_tp',
    },
    {
        fieldType: 'ai-form-date-box',
        title: 'Начало поставки',
        groupId: 2,
        size: [1, 1],
        fieldNameText: 'dat_postav_obj',
    },
    {
        fieldType: 'ai-form-date-box',
        title: 'Дата искл. из расчетов по насел.',
        groupId: 2,
        size: [1, 1],
        fieldNameText: 'mkd_date_excld_calc',
    },
    {
        fieldType: 'ai-form-date-box',
        title: 'Дата начала аренды',
        groupId: 2,
        size: [1, 1],
        fieldNameText: 'dat_beg_arend',
    },
    {
        fieldType: 'ai-form-date-box',
        title: 'Дата окончания аренды',
        groupId: 2,
        size: [1, 1],
        fieldNameText: 'dat_end_arend',
    }, //Реквизиты
    {
        fieldType: 'ai-form-text-box-readonly',
        title: 'Адрес ФИАС',
        groupId: 3,
        size: [1, 1],
        fieldNameText: 'fias',
    },
    {
        fieldType: 'ai-form-text-box-readonly',
        title: 'Ид-р внешней системы (И)',
        groupId: 3,
        size: [1, 1],
        fieldNameText: 'es_id',
    },
    {
        fieldType: 'ai-form-text-box-readonly',
        title: 'Ид-ры внешних систем',
        groupId: 3,
        size: [1, 4],
        fieldNameText: 'es_ids',
    },
    {
        fieldType: 'ai-form-check-box',
        title: 'Печать списком',
        groupId: 3,
        size: [1, 1],
        fieldNameText: 'prizn_prn',
    },
    {
        fieldType: 'ai-form-select-box',
        title: 'Условия отключений',
        groupId: 3,
        size: [1, 1],
        fieldNameText: 'kod_uslotkl',
        fieldNameId: 'usl_abbr',
        extParams: {
            valueExpr: 'kod_uslotkl',
            displayExpr: 'abbr',
            dictionaryRoutePath: 'object./uslotkl/data/get',
        },
    },
    {
        fieldType: 'ai-form-text-box',
        title: 'Очередь отключений',
        groupId: 3,
        size: [1, 1],
        fieldNameText: 'tlg_och',
    },
    {
        fieldType: 'ai-form-check-box',
        title: 'АСКУЭ',
        groupId: 3,
        size: [1, 1],
        fieldNameText: 'askue',
    },
    {
        fieldType: 'ai-form-text-box-grid-ro-dictionary',
        title: 'Принадл. оборуд. на праве',
        groupId: 3,
        size: [1, 1],
        fieldNameId: 'kod_obj_fs',
        fieldNameText: 'fs_abbr',
        extParams: {
            displayExpr: 'abbr',
            valueExpr: 'kod_obj_fs',
            meta: {
                keyExpr: 'kod_obj_fs',
                columns: [
                    {
                        dataField: 'kod_obj_fs',
                        caption: 'kod_obj_fs',
                        visible: false,
                    },
                    {
                        dataField: 'name',
                        caption: 'Наименование',
                    },
                    {
                        dataField: 'abbr',
                        caption: 'Аббревиатура',
                    },
                    {
                        dataField: 'tep_el',
                        caption: 'Тепло / Эл-во',
                    },
                ],
                api: { select: 'object./obj_fs/data/get' },
            },
        },
    },
    {
        fieldType: 'ai-form-check-box',
        title: 'Перечень по пост. 442',
        groupId: 3,
        size: [1, 1],
        fieldNameText: 'vkl530',
    },
    {
        fieldType: 'ai-form-check-box',
        title: 'Бездоговорное использование',
        groupId: 3,
        size: [1, 1],
        fieldNameText: 'bezdog',
    },
    {
        fieldType: 'ai-form-text-box',
        title: 'Допустимый %откл. Факт. расхода',
        groupId: 3,
        size: [1, 1],
        fieldNameText: 'divergence_percent',
    },
    {
        fieldType: 'ai-form-check-box',
        title: 'Участие в расчете аванса',
        groupId: 3,
        size: [1, 1],
        fieldNameText: 'pr_avans',
    },
    {
        fieldType: 'ai-form-radio-box',
        title: 'Зона',
        groupId: 3,
        size: [1, 1],
        fieldNameText: 'zone',
        extParams: {
            displayExpr: 'zone_name',
            valueExpr: 'zone',
            layout: 'horizontal',
            items: [
                {
                    zone: 0,
                    zone_name: 'ГП',
                },
                {
                    zone: 1,
                    zone_name: 'СК',
                },
            ],
        },
    },
    {
        fieldType: 'ai-form-text-box',
        title: 'Сетевая организация',
        groupId: 3,
        size: [1, 1],
        fieldNameText: 'name_usl',
    },

    {
        fieldType: 'ai-form-text-box',
        title: 'Описание точки поставки',
        groupId: 3,
        size: [1, 1],
        fieldNameText: 'point_sale',
    },
    {
        fieldType: 'ai-form-check-box',
        title: 'Договор техн. присоед.',
        groupId: 3,
        size: [1, 1],
        fieldNameText: 'pr_dog_tehpris',
    },
    {
        fieldType: 'ai-form-check-box',
        title: 'Аварийный МКД',
        groupId: 3,
        size: [1, 1],
        fieldNameText: 'mkd_pr_unsafe_house',
    },
    {
        fieldType: 'ai-form-text-box',
        title: 'УИН',
        groupId: 3,
        size: [1, 1],
        fieldNameText: 'uin',
    },
    {
        fieldType: 'ai-form-text-box',
        title: '№ заявки в CRM',
        groupId: 3,
        size: [1, 1],
        fieldNameText: 'req_crm',
    },
    {
        fieldType: 'ai-form-text-box',
        title: '№ заявки в ЛКП',
        groupId: 3,
        size: [1, 1],
        fieldNameText: 'req_lk',
    },
    {
        fieldType: 'ai-form-multiline-text-box',
        title: 'Примечания',
        groupId: 3,
        size: [1, 6],
        fieldNameText: 'prim',
    },
];

const emptyObjectCard = {
    result: true,
    success: true,
    data: {
        kod_numobj: null,
        kod_obj: null,
        kod_parent_sa: null,
        kod_f23: null,
        name23: null,
        pr_active: null,
        active_abbr: null,
        tep_el: null,
        tep_el_name: null,
        tarif: null,
        tarif_name: null,
        kod_dog: null,
        ndog: null,
        dep: null,
        dep_name: null,
        kodp: null,
        contragent_name: null,
        kodagent: null,
        ag_name: null,
        num_obj: null,
        name: null,
        kodnaznhouse: null,
        naznhouse_name: null,
        dat_create: null,
        dat_parent_create: null,
        dat_fin: null,
        dat_plan_fin: null,
        dat_tp: null,
        dat_postav_obj: null,
        dat_replace: null,
        prizn_prn: null,
        kod_parent_obj: null,
        parent_obj: null,
        prim: null,
        kodd: null,
        kf_adress_o: null,
        fias: null,
        kod_uslotkl: null,
        usl_abbr: null,
        tlg_och: null,
        askue: null,
        kod_obj_fs: null,
        fs_abbr: null,
        dat_beg_arend: null,
        dat_end_arend: null,
        vkl530: null,
        bezdog: null,
        divergence_percent: null,
        pr_avans: null,
        zone: null,
        zone_name: null,
        kodp_usl: null,
        name_usl: null,
        point_sale: null,
        pr_dog_tehpris: null,
        es_id: null,
        es_ids: null,
        kodp_seti: null,
        seti_name: null,
        mkd_pr_unsafe_house: null,
        mkd_date_excld_calc: null,
        square_oi: null,
        square: null,
        kol_kom: null,
        apartment: null,
        square_rent: null,
        nrm_soi: null,
        kod_dopdoc: null,
        uin: null,
        req_crm: null,
        req_lk: null,
    },
};

const widgetList = [
    // {
    //     name: 'Точки учета', // caption:['kindname','dnum'],
    //     icon: '/infoenergo/assets/widget_notebook.svg', // component: WidgetEotransGe
    // },
    {
        name: 'Пользовательские атрибуты',
        caption: ['num_obj', 'name'],
        icon: '/infoenergo/assets/widget_additional_documents.svg',
        width: '40vw',
        height: '50vh',
        component: WidgetObjectUserAttributes,
    },
];

const getObjectWidgetList = () => {
    return widgetList.map(widget => {
        const { component, ...rest } = widget;
        return {
            ...rest,
            id: 'widget-' + Math.floor(Math.random() * Date.now()).toString(),
            visible: false,
            component: markRaw(component),
        };
    });
};
export default {
    cardMeta: {
        groups,
        components,
    },
    emptyObjectCard,
    getObjectWidgetList,
};
